<template>
  <!-- ******HEADER****** -->
  <header id="header" class="header px-3 py-3">
    <nav class="main-nav navbar-expand-xl" role="navigation" style="padding:0px;">
      <div class="container-fluid position-relative">

        <template v-if="isScroll">
          <a class="logo navbar-brand scrollto" href="#main-screen">
            <img :src="publicPath+'assets/img/logo/logo.png'">
          </a>

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-collapse"  aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

          <div id="navbar-collapse" class="navbar-collapse collapse">
            <ul class="nav navbar-nav ms-md-auto mt-2 mb-4">
              <li class="nav-item">
                <a class="nav-link scrollto nav-margin" href="#about">농장:쏙 이란</a>
              </li>
              <li class="nav-item">
                <a class="nav-link scrollto nav-margin" href="#testimonials">서비스소개</a>
              </li>
              <li class="nav-item">
                <a class="nav-link scrollto nav-margin" href="#features">서비스현황</a>
              </li>
              <li class="nav-item">
                <a class="nav-link scrollto nav-margin" href="#appstore">앱다운로드</a>
              </li>
<!--              <li class="nav-item">-->
<!--                <a class="nav-link scrollto nav-margin" href="#service">서비스문의</a>-->
<!--              </li>-->
            </ul>
          </div>
        </template>
        <template v-else>
          <router-link class="logo navbar-brand" to="/#main-screen">
            <img :src="publicPath+'assets/img/logo/logo.png'">
          </router-link>
<!--          <a class="logo navbar-brand" href="/#main-screen">-->
<!--            <img :src="publicPath+'assets/img/logo/logo.png'">-->
<!--          </a>-->

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-collapse"  aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button><!--//nav-toggle-->

          <div id="navbar-collapse" class="navbar-collapse collapse">
            <ul class="nav navbar-nav ms-md-auto mt-2 mb-4">
              <li class="nav-item">
                <router-link class="nav-link nav-margin" to="/#about">농장:쏙 이란</router-link>
<!--                <a class="nav-link nav-margin" href="/#about">농장:쏙 이란</a>-->
              </li>
              <li class="nav-item">
                <router-link class="nav-link nav-margin" to="/#testimonials">서비스소개</router-link>
<!--                <a class="nav-link nav-margin" href="/#testimonials">서비스소개</a>-->
              </li>
              <li class="nav-item">
                <router-link class="nav-link nav-margin" to="/#features">서비스현황</router-link>
<!--                <a class="nav-link nav-margin" href="/#features">서비스현황</a>-->
              </li>
              <li class="nav-item">
                <router-link class="nav-link nav-margin" to="/#appstore">앱다운로드</router-link>
<!--                <a class="nav-link nav-margin" href="/#appstore">앱다운로드</a>-->
              </li>
<!--              <li class="nav-item">-->
<!--                <a class="nav-link nav-margin" href="/#service">서비스문의</a>-->
<!--              </li>-->
            </ul>
          </div>
        </template>


      </div>
      <!--//container-->

    </nav>
    <!--//main-nav-->
  </header>
  <!--//header-->
</template>
<script>
export default{
  data(){
    return {
      publicPath: process.env.BASE_URL,
      isScroll: true
    }
  },
  watch: {
    '$route' (to) {
      // console.log(to.path);
      if(to.path.includes("#") || to.path==="/"){
        this.isScroll = true;
        // document.querySelector("#header").classList.add('header-scrolled');
      }else{
        this.isScroll = false;
        // document.querySelector("#header").classList.remove('header-scrolled');
        // window.scrollTo({top: 0});
      }
      // console.log(this.isScroll);
    }
  },
  mounted() {
  },
  methods:{
  },
}
</script>
